export function getListItems(tags) {
  if (tags.length === 1) {
    return []
  }

  return tags
}
